(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["back"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    const roots = scope.matches?.('[data-front-preview]') ? [scope] : scope.querySelectorAll('[data-front-preview]');
    roots.forEach((root) => {
      if (root.dataset.frontReady) return;
      const frontImage = root.querySelector('[data-front-image]');
      const pantsImage = root.querySelector('[data-pants-image]');
      const viewControls = root.querySelector('[data-front-controls]');
      const garmentControls = root.querySelector('[data-garment-controls]');
      const hoodieControls = root.querySelector('[data-hoodie-controls]');
      const pantsNote = root.querySelector('[data-pants-note]');
      const error = root.querySelector('[data-preview-error]');
      const buttons = [...root.querySelectorAll('[data-view-choice]')];
      const garments = [...root.querySelectorAll('[data-garment-choice]')];
      if (!frontImage || !pantsImage || !viewControls || !garmentControls || !hoodieControls) return;
      root.dataset.frontReady = 'true';
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const failedSources = new Set();
      const previews = new Map();
      const stage = root.querySelector('[data-stage]');
      let intent = 0;
      let requestedGarment = 'hoodie';
      let requestedView = 'front';
      let disposed = false;
      let warmObserver;
      const sourceFor = (garment, view, colour = root.dataset.colour === 'ember' ? 'ember' : 'oxblood') => {
        if (garment === 'pants') return root.dataset[colour + 'Pants' + (view === 'front' ? 'Front' : 'Back')];
        return view === 'front' ? root.dataset[colour + 'Front'] : root.dataset[colour + 'Base'];
      };
      const prepare = (source, priority = 'low') => {
        if (!source) return Promise.reject(new Error('Missing preview'));
        if (previews.has(source)) {
          const cached = previews.get(source);
          if (!cached.ready && priority === 'high') cached.image.fetchPriority = 'high';
          return cached.promise;
        }
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.decoding = 'async';
        image.fetchPriority = priority;
        const entry = { image, ready: false };
        entry.promise = new Promise((resolve, reject) => {
          image.onload = () => {
            const decoded = image.decode ? image.decode().catch(() => {}) : Promise.resolve();
            decoded.then(() => { entry.ready = true; resolve(image); });
          };
          image.onerror = () => { previews.delete(source); reject(new Error('Preview unavailable')); };
          image.src = source;
        });
        previews.set(source, entry);
        return entry.promise;
      };
      const warmColour = (colour) => {
        ['hoodie', 'pants'].forEach((garment) => ['front', 'back'].forEach((view) => {
          prepare(sourceFor(garment, view, colour)).catch(() => {});
        }));
      };
      const isUnavailable = (garment, view) => !sourceFor(garment, view) || failedSources.has(sourceFor(garment, view));
      const render = () => {
        let garment = root.dataset.garment === 'pants' ? 'pants' : 'hoodie';
        let view = root.dataset.view === 'front' ? 'front' : 'back';
        const pantsUnavailable = isUnavailable('pants', 'front') && isUnavailable('pants', 'back');
        if (garment === 'pants' && pantsUnavailable) garment = 'hoodie';
        if (isUnavailable(garment, view)) view = view === 'front' ? 'back' : 'front';
        root.dataset.garment = garment;
        root.dataset.view = view;
        const isPants = garment === 'pants';
        const label = root.dataset.colour === 'ember' ? 'Ember' : 'Afterhours';
        buttons.forEach((button) => {
          button.disabled = isUnavailable(garment, button.dataset.viewChoice);
          button.setAttribute('aria-pressed', String(button.dataset.viewChoice === view));
        });
        garments.forEach((button) => {
          button.disabled = button.dataset.garmentChoice === 'pants' && pantsUnavailable;
          button.setAttribute('aria-pressed', String(button.dataset.garmentChoice === garment));
        });
        hoodieControls.hidden = isPants || view === 'front';
        pantsImage.hidden = !isPants;
        pantsNote.hidden = !isPants;
        if (isPants) {
          pantsImage.alt = root.dataset[view === 'front' ? 'pantsFrontAlt' : 'pantsBackAlt'].replace('__COLOUR__', label);
          const source = sourceFor('pants', view);
          if (pantsImage.getAttribute('src') !== source) pantsImage.src = source;
        } else {
          frontImage.alt = root.dataset.frontAlt.replace('__COLOUR__', label);
          const source = sourceFor('hoodie', 'front');
          if (frontImage.getAttribute('src') !== source) frontImage.src = source;
        }
      };
      const select = (garment, view) => {
        const token = ++intent;
        requestedGarment = garment;
        requestedView = view;
        error.hidden = true;
        const source = sourceFor(garment, view);
        const apply = () => {
          if (disposed || token !== intent) return;
          stage.removeAttribute('aria-busy');
          root.dataset.garment = garment;
          root.dataset.view = view;
          render();
          requestedGarment = root.dataset.garment;
          requestedView = root.dataset.view;
        };
        if (previews.get(source)?.ready) apply();
        else {
          stage.setAttribute('aria-busy', 'true');
          prepare(source, 'high').then(apply, () => {
            if (disposed || token !== intent) return;
            stage.removeAttribute('aria-busy');
            failedSources.add(source);
            error.hidden = false;
            render();
            requestedGarment = root.dataset.garment;
            requestedView = root.dataset.view;
          });
        }
        warmColour(root.dataset.colour === 'ember' ? 'ember' : 'oxblood');
      };
      const setView = (view) => select(requestedGarment, view);
      const showPrint = () => {
        select('hoodie', 'back');
      };
      buttons.forEach((button) => button.addEventListener('click', () => setView(button.dataset.viewChoice), options));
      garments.forEach((button) => button.addEventListener('click', () => {
        select(button.dataset.garmentChoice, requestedView);
      }, options));
      root.addEventListener('click', (event) => {
        if (event.target.closest('.s-back__opt, [data-guide-btn], .s-back__filebtn, [data-clear]')) showPrint();
      }, options);
      root.addEventListener('change', (event) => {
        if (event.target.matches('[name="back-design"], [data-file], [data-size], [data-height], [data-knockout]')) showPrint();
      }, options);
      root.addEventListener('input', (event) => {
        if (event.target.matches('[data-size], [data-height], [data-knockout]')) showPrint();
      }, options);
      [frontImage, pantsImage].forEach((image) => {
        const imageFailed = () => {
          const source = image.getAttribute('src');
          if (!source) return;
          failedSources.add(source);
          error.hidden = false;
          render();
        };
        image.addEventListener('error', imageFailed, options);
        image.addEventListener('load', () => {
          failedSources.delete(image.getAttribute('src'));
          render();
        }, options);
        if (image.getAttribute('src') && image.complete && !image.naturalWidth) imageFailed();
      });
      let observedColour = root.dataset.colour === 'ember' ? 'ember' : 'oxblood';
      const observer = new MutationObserver(() => {
        const colour = root.dataset.colour === 'ember' ? 'ember' : 'oxblood';
        if (colour === observedColour) return;
        observedColour = colour;
        ++intent;
        stage.removeAttribute('aria-busy');
        error.hidden = true;
        render();
        requestedGarment = root.dataset.garment;
        requestedView = root.dataset.view;
        warmColour(colour);
      });
      observer.observe(root, { attributes: true, attributeFilter: ['data-colour'] });
      viewControls.hidden = false;
      garmentControls.hidden = false;
      root.dataset.view = 'front';
      render();
      const warm = () => warmColour(root.dataset.colour === 'ember' ? 'ember' : 'oxblood');
      if ('IntersectionObserver' in window) {
        warmObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) { warmObserver.disconnect(); warm(); }
        }, { rootMargin: '400px 0px' });
        warmObserver.observe(root);
      } else warm();
      root.addEventListener('pointerover', (event) => {
        const input = event.target.closest('.s-back__colour')?.querySelector('input');
        if (input) warmColour(input.value);
      }, options);
      root.addEventListener('focusin', (event) => {
        if (event.target.matches('[name="back-colour"]')) warmColour(event.target.value);
      }, options);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) {
          disposed = true;
          ++intent;
          warmObserver?.disconnect();
          previews.clear();
          observer.disconnect();
          controller.abort();
          delete root.dataset.frontReady;
        }
      }, options);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-mobile-toggle]').forEach(toggle => {
      if (toggle.dataset.mobileReady) return;
      const header = toggle.closest('.site-header');
      const menu = header.querySelector('[data-mobile-menu]');
      if (!menu) return;
      toggle.dataset.mobileReady = 'true';
      const label = toggle.querySelector('[data-nav-label]');
      const originalLabel = label.textContent;
      const desktop = matchMedia('(min-width: 901px)');
      let opened = false, previousOverflow = '', inertElements = [];
      const setOpen = (value, returnFocus = false) => {
        if (value === opened) return;
        opened = value;
        toggle.setAttribute('aria-expanded', String(value));
        menu.inert = !value;
        menu.classList.toggle('is-open', value);
        label.textContent = value ? 'Close' : originalLabel;
        if (value) {
          header.style.setProperty('--mobile-menu-top', `${header.getBoundingClientRect().bottom}px`);
          previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          inertElements = Array.from(document.querySelectorAll('main, .announce, .site-footer')).filter(el => !el.inert);
          inertElements.forEach(el => { el.inert = true; });
        } else {
          document.body.style.overflow = previousOverflow;
          inertElements.forEach(el => { el.inert = false; });
          inertElements = [];
          if (returnFocus) toggle.focus();
        }
      };
      toggle.addEventListener('click', () => setOpen(!opened));
      menu.addEventListener('click', event => {
        if (event.target.closest('a')) setOpen(false);
      });
      header.addEventListener('keydown', event => {
        if (!opened) return;
        if (event.key === 'Escape') { event.preventDefault(); setOpen(false, true); }
        if (event.key === 'Tab') {
          const controls = [toggle, ...menu.querySelectorAll('a[href]')];
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      desktop.addEventListener('change', event => { if (event.matches) setOpen(false); });
      window.addEventListener('pageshow', () => setOpen(false));
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(header)) setOpen(false);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panelshop"] && !Shopify.designMode) return;
  try {
    
(() => {
  let instance = 0;
  const initialize = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-panel-shop]')];
    if (scope.matches?.('[data-panel-shop]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.panelReady) return;
      root.dataset.panelReady = 'true';
      const events = new AbortController();
      const options = { signal: events.signal };
      const list = root.querySelector('[data-panel-list]');
      const detail = root.querySelector('[data-panel-detail]');
      const title = root.querySelector('[data-panel-title]');
      const material = detail.querySelector('[data-panel-material]');
      const price = detail.querySelector('[data-panel-price]');
      const stage = root.querySelector('[data-panel-stage]');
      const isolated = root.querySelector('[data-panel-isolated]');
      const reverse = root.querySelector('[data-panel-reverse]');
      const reverseNote = root.querySelector('[data-panel-reverse-note]');
      const recommended = root.querySelector('[data-panel-recommended]');
      const jacketLink = root.querySelector('[data-panel-jacket-link]');
      const viewButtons = [...root.querySelectorAll('[data-panel-view]')];
      const cards = new Map([...root.querySelectorAll('[data-panel-card]')].map(card => [card.dataset.panelHandle, card]));
      const originalTitle = document.title;
      const prefix = `panel-detail-${++instance}`;
      let active = '', view = 'panel', gridScroll = 0;
      const artwork = (card, suffix) => {
        const svg = card.querySelector('svg').cloneNode(true);
        const ids = new Map([...svg.querySelectorAll('[id]')].map(node => [node.id, `${prefix}-${suffix}-${node.id}`]));
        svg.querySelectorAll('*').forEach(node => {
          for (const attribute of [...node.attributes]) {
            let value = attribute.value;
            if (attribute.name === 'id' && ids.has(value)) value = ids.get(value);
            else if (attribute.name === 'aria-labelledby') value = value.split(' ').map(id => ids.get(id) || id).join(' ');
            else {
              value = value.replace(/url\(#([^)]*)\)/g, (match, id) => ids.has(id) ? `url(#${ids.get(id)})` : match);
              if (value.startsWith('#') && ids.has(value.slice(1))) value = `#${ids.get(value.slice(1))}`;
            }
            if (value !== attribute.value) node.setAttribute(attribute.name, value);
          }
        });
        const labelledBy = svg.getAttribute('aria-labelledby');
        if (ids.has(labelledBy)) svg.setAttribute('aria-labelledby', ids.get(labelledBy));
        svg.setAttribute('class', 'panel-product__art');
        return svg;
      };
      const updateView = () => {
        stage.dataset.view = view;
        isolated.hidden = view !== 'panel';
        reverse.hidden = view !== 'details';
        reverseNote.hidden = view !== 'details';
        viewButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.panelView === view)));
      };
      const normalize = url => {
        url.searchParams.delete('jacket');
        url.searchParams.delete('view');
        if (url.searchParams.get('panel_view') !== 'details') url.searchParams.delete('panel_view');
        if (url.href !== location.href) history.replaceState(history.state, '', url);
        return url;
      };
      const render = ({ focus = false, scroll = false } = {}) => {
        const url = normalize(new URL(location.href));
        const handle = url.searchParams.get('panel');
        const card = cards.get(handle);
        if (!card) {
          const previous = active;
          active = '';
          isolated.replaceChildren();
          detail.hidden = true;
          list.hidden = false;
          document.title = originalTitle;
          if (scroll) {
            window.scrollTo({ top: history.state?.panelShopScroll ?? gridScroll, behavior: 'instant' });
            if (focus && previous) cards.get(previous)?.querySelector('[data-panel-link]').focus({ preventScroll: true });
          }
          return;
        }
        const changed = active !== handle;
        active = handle;
        title.textContent = card.dataset.panelName;
        material.textContent = card.dataset.panelMaterial;
        price.textContent = card.dataset.panelPrice;
        const pairing = card.dataset.panelJacket === 'ember' ? 'ember' : 'oxblood';
        recommended.textContent = recommended.dataset[`${pairing}Label`];
        jacketLink.href = `${jacketLink.dataset.jacketBase}${pairing}-hoodie`;
        view = url.searchParams.get('panel_view') === 'details' ? 'details' : 'panel';
        if (changed) isolated.replaceChildren(artwork(card, 'solo'));
        updateView();
        list.hidden = true;
        detail.hidden = false;
        document.title = `${card.dataset.panelName} · ${originalTitle}`;
        if (scroll) root.scrollIntoView({ behavior: 'instant', block: 'start' });
        if (focus) title.focus({ preventScroll: true });
      };
      root.addEventListener('click', event => {
        const link = event.target.closest('[data-panel-link], [data-panel-all]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (!active) {
          gridScroll = window.scrollY;
          history.replaceState({ ...history.state, panelShopScroll: gridScroll }, '', location.href);
        }
        history.pushState({ ...history.state, panelShopScroll: gridScroll }, '', new URL(link.href, location.href));
        render({ focus: true, scroll: true });
      }, options);
      viewButtons.forEach(button => button.addEventListener('click', () => {
        if (!active) return;
        view = button.dataset.panelView === 'details' ? 'details' : 'panel';
        updateView();
        const url = new URL(location.href);
        if (view === 'details') url.searchParams.set('panel_view', 'details');
        else url.searchParams.delete('panel_view');
        normalize(url);
      }, options));
      window.addEventListener('popstate', () => render({ focus: true, scroll: true }), options);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) {
          events.abort();
          delete root.dataset.panelReady;
          document.title = originalTitle;
        }
      }, options);
      render();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
